import Lightning from "@lightningjs/sdk/src/Lightning";
import FTTrickPlayOptions from "./ft-trickplay-options";
import FTTrickPlayInterface from "./ft-trickplay-interface";
import { getTrickPlayUrl } from "../../models/data-service";
import { Logger } from "../../logger";
import { ItemNode } from "../grid/ItemNode";

export default class FTTrickPlayUI
  extends Lightning.Component<Lightning.Component.TemplateSpecLoose>
  implements Lightning.Component<Lightning.Component.TemplateSpecLoose>
{
    ftTrickplay:any;
    trickplayError=false;
    player:any;
    videoInfo!: ItemNode
    static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
        return {
            ...super._template(),
            w: (w: any) => w,
            h: (h: any) => h,
            /*TitleText: {
                x: (w: any) => 100,
                y: (h: any) => 300,
                w: (w: any) => w,
                text: {
                    text: "TEST",
                    fontSize: 50,
                    fontFace: "SFPro-Black",
                    letterSpacing: 0.82,
                    textOverflow: "ellipsis",
                    wordWrap: false,
                    wordWrapWidth: 1500,
                },
            },*/
            visible:false
          };
    }
    override _init() {
        this.patch({
            visible: false,
        });
    }
    override _handleLeft() {
        if(this.ftTrickplay){
            this.ftTrickplay.moveLeft();
        }
        this.fireAncestors("$resetInactivityTimer");
    }
    override _handleRight() {
        if(this.ftTrickplay){
            this.ftTrickplay.moveRight();
        }
        this.fireAncestors("$resetInactivityTimer");
    }
    override _handleEnter() {
        if(this.ftTrickplay){
            this.ftTrickplay.processOk();
        }
        this.fireAncestors("$resetInactivityTimer");
    }
    override _handleBack() {
        this.player.focusedRowIndex = 1;
        this.player._setState('MediaButtonsState');
        this.player.showController(true);
    }


    initTrickplay(videoInfo:any,player:any){
        this.player=player;
        this.videoInfo = videoInfo
        var elemDiv = document.createElement("div");
        elemDiv.setAttribute("id", "trickplay-container");
        elemDiv.style.cssText = "position: absolute;overflow: hidden;width: 100%;height: 30vh;bottom: 0;margin-bottom:16vh;z-index: 10;display:none;";
        document.body.appendChild(elemDiv);
        var tpO = new FTTrickPlayOptions();
        tpO.url = getTrickPlayUrl(videoInfo.node_id);
        //'http://rapi.ifood.tv/tp.php?appId=2&auth-token=1213111&version=sv7.0&deviceId=&feedId=10334663';
        tpO.videoElement = this;
        tpO.thumbnailContainer = $('#trickplay-container')[0];
        this.ftTrickplay = new FTTrickPlayInterface(tpO);
        this.ftTrickplay.on('trickplay', this.trickplayHandler, this);
        this.ftTrickplay.on('trickplayShow', this.trickplayShowHandler, this);
        this.ftTrickplay.on('trickplayHide', this.trickplayHideHandler, this);
        this.ftTrickplay.on('trickplayAutoHide', this.trickplayAutoHideHandler, this);
        this.ftTrickplay.on('trickplaySelected', this.trickplaySelectedHandler, this);
        this.ftTrickplay.on('trickplayError', this.trickplayErrorHandler, this);
        this.ftTrickplay.init();
    }

    _getActionKey() {
      if (this.player) {
        return `${this.player._getActionKey()}`
      }
      return ''
    }

    trickplayHandler(event: any) {
        if(this.ftTrickplay){
            this.ftTrickplay.renderTrickPlayImages(event);
        }
    }

    trickplayShowHandler(event: any) {
        Logger.processUserAction('trickplay_show', this._getActionKey());
    }

    trickplayHideHandler(event: any) {
        Logger.processUserAction('trickplay_hide', this._getActionKey());
    }
    trickplayAutoHideHandler(event: any) {
        if(this.player){
            this.player.trickplayAutoHideHandler(event);
        }
    }

    trickplaySelectedHandler(event: any) {
        if(this.player){
            this.player.trickplaySelectedHandler(event);
        }
    }

    trickplayErrorHandler(event: any) {
        this.trickplayError = true;
    }

    trickPlayLog(){
    }

    show(isInteractive = false){
        if(this.trickplayError){
            return;
        }
        this.patch({
            visible: true,       
        });
        this._animateTrickplayDiv(true);
        if(this.ftTrickplay){
            this.ftTrickplay.show(isInteractive);
        }
    }

    hide(){
        if(this.trickplayError){
            return;
        }
        this.patch({
            visible: false,     
        });
        this._animateTrickplayDiv(false);
        if(this.ftTrickplay){
            this.ftTrickplay.hide();
        }
    }

    _animateTrickplayDiv(isShow: boolean) {
        const container = document.getElementById('trickplay-container');
        if (!container) return;
        if (isShow) {
            container.style.transition = 'none';
            container.style.display = 'block';
            container.style.transform = 'translateY(100%)';
            container.style.opacity = '0';
            container.getBoundingClientRect();
            container.style.transition = `transform 500ms ease-out, opacity 500ms ease-out`;
            container.style.transform = 'translateY(0%)';
            container.style.opacity = '1';
        } else {
          container.style.transition = `transform 500ms ease-out, opacity 500ms ease-out`;
            container.style.transform = 'translateY(100%)';
            container.style.opacity = '0';
        }
    }

    setFocused(focused: boolean) {
        if (this.ftTrickplay) {
            this.ftTrickplay.setInteractive(focused);
        }
    }

    setPlayerTime(currentTime:any){
        if(!this.trickplayError){
            if(this.ftTrickplay){
                this.ftTrickplay.setPlayerTime(currentTime);
            }
        }
    }

    setVideoDuration(duration:any){
        if(!this.trickplayError){
            if(this.ftTrickplay){
                this.ftTrickplay.setVideoDuration(duration);
            }
        }
    }

    destroy(){
        if (this.ftTrickplay) {
            this.ftTrickplay.destroy();
        }
        const element = document.getElementById("trickplay-container");
        if(element){
            element.remove();
        }
        this.ftTrickplay = null;
        this.trickplayError=false;
    }
}
